import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ActionSheetController, LoadingController, ModalController, ViewController } from 'ionic-angular';
import { BusinessProductPaymentCheckoutPage } from '../business-product-payment-checkout/business-product-payment-checkout';
import { BusinessProductDetailPage } from '../business-product-detail/business-product-detail';
import { BusinessProductPaymentManagerHandler } from '../../providers/business-product-payment-handler';
import { ConsumerHandlerProvider } from '../../providers/consumer-handler';
import { ProductPaymentCheckoutHandler } from '../../providers/product-payment-checkout-handler';
import { BarcodeScanner, BarcodeScannerOptions } from '@ionic-native/barcode-scanner';
import { Globals } from '../../providers/globals';

/**
 * Generated class for the BusinessProductCategoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-business-product-category',
  templateUrl: 'business-product-category.html',
})
export class BusinessProductCategoryPage {
	category: any;
	filteredProducts: any = [{
		Count: 0,
		Initial: ''
	}];

	selectedTotal: any = 0;
	selectedProducts: any = [];

	hasProducts: boolean = false;
	filePath: any;
	loader: any;
	isLoading: boolean = false;
	loadingMsg: any = "Loading...";
	userIsLoading: boolean = false

	params: any = {
		subcategoryId: null,
		page: 1,
		size: 20,
		cb: null
	}

	options: BarcodeScannerOptions;
	results: {
	    text: string,
	    cancelled: boolean
	};

  constructor(
  	public navCtrl: NavController, 
		public navParams: NavParams,
		public productManagerHandler: BusinessProductPaymentManagerHandler,
		public checkoutHandler: ProductPaymentCheckoutHandler,
		public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public actionSheetCtrl: ActionSheetController,
		public modalCtrl: ModalController,
		public globals: Globals,
		private barcodeScanner: BarcodeScanner,
		public viewCtrl: ViewController
		) {
		this.filePath = this.globals.fileUrl;

		this.category = navParams.get('category');

		this.params.subcategoryId = this.category.Id;
  }

  ionViewDidLoad() {
		this.load(null);
	}			

	load(cb){
		this.isLoading = true;

		this.params.cb = (results)=>{

			for(let product of results){
				product.Initial = product.ProductName.charAt(0)
			}

			this.filteredProducts = results;

			this.isLoading = false;

			if(typeof cb == "function")
				cb()			
		}
		
		this.productManagerHandler.getProductsBySubCategory(this.params)
	}

	presentProductModal($e, product) {
		// if(subcategory.ProductCount > 0) {
		   let productModal = this.modalCtrl.create(BusinessProductDetailPage, {product: product});

		   productModal.onDidDismiss(productsToAdd => {
		   		if(productsToAdd){
				     for(let product of productsToAdd){
				     	
				     	this.addProduct(null, product);
				     }

				     this.addToOrder();
					}
		   });

		   productModal.present();
		// }
	 }

	addToOrder(){

   		this.viewCtrl.dismiss(this.selectedProducts);
	}

	cancel(){

		this.selectedTotal = 0;

		this.selectedProducts = [];

   		this.viewCtrl.dismiss(this.selectedProducts);

	}

	addProduct($e, product) {

		this.selectProduct(null, product)
	}

	selectProduct($e, product) {

		product.Count = product.Count ? product.Count + 1 : 1;

		this.selectedTotal += product.Price;

		this.selectedProducts.push(product)
	}

	removeProduct($e, product) {

		this.selectedTotal -= product.Price;

		product.Count = product.Count ? product.Count - 1 : 0;

		if(product.Count == 0) {

			this.selectedProducts = this.selectedProducts.filter(function(item) {
			    return item.Id != product.Id;
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/pages/business-product-category/business-product-category.ts